import {
  GET_TAX_MANAGEMENT,
  SET_PAGE,
  SET_SEARCH,
} from "../../shared/constants/ActionTypes";
import moment from "moment";

const initalTaxManagement = {
  taxManagement: [],
  taxManagementCount: 0,
  page: 1,
  search: "",
};

function taxManagementReducer(state = initalTaxManagement, action) {
  switch (action.type) {
    case GET_TAX_MANAGEMENT:
      return {
        ...state,
        taxManagement: action.payload.tax.map((taxes) => {
          return {
            ...taxes,
            updatedAtFormatted: moment(taxes.createdAt).format("ll"),
          };
        }),
        taxManagementCount: action.payload.total,
      };
    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };

    default:
      return state;
  }
}

export default taxManagementReducer;
